module.exports = __webpack_public_path__ + "static/media/jira_intial_notification_setup.57ccd0ab.jpeg";